interface Props {
  bars: number[][];
  boundary?: number | null;
  highlight?: number;
}

export function CandlestickChart({ bars, boundary, highlight }: Props) {
  const width = 720;
  const height = 320;
  const padding = { top: 24, right: 24, bottom: 34, left: 52 };
  const values = bars.flatMap((bar) => [bar[1], bar[2]]);
  const min = Math.min(...values, boundary ?? Infinity);
  const max = Math.max(...values, boundary ?? -Infinity);
  const span = max - min || 1;
  const x = (index: number) => padding.left + (index + 0.5) * (width - padding.left - padding.right) / bars.length;
  const y = (value: number) => padding.top + (max - value) / span * (height - padding.top - padding.bottom);
  const candleWidth = Math.min(42, (width - padding.left - padding.right) / bars.length * 0.52);
  return (
    <div className="chart-frame">
      <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label={`${bars.length}根教学K线，目标K线已标记`}>
        {[0, 1, 2, 3, 4].map((index) => {
          const value = min + span * index / 4;
          return <g key={index}><line className="chart-grid" x1={padding.left} x2={width - padding.right} y1={y(value)} y2={y(value)} /><text className="chart-axis" x={padding.left - 8} y={y(value) + 4} textAnchor="end">{value.toFixed(1)}</text></g>;
        })}
        {boundary != null && <g><line className="chart-boundary" x1={padding.left} x2={width - padding.right} y1={y(boundary)} y2={y(boundary)} /><text className="chart-axis" x={width - padding.right} y={y(boundary) - 7} textAnchor="end">结构边界</text></g>}
        {bars.map(([open, high, low, close], index) => {
          const bullish = close >= open;
          const bodyTop = Math.min(y(open), y(close));
          const bodyHeight = Math.max(2, Math.abs(y(open) - y(close)));
          return <g key={index} className={`chart-candle ${bullish ? "bull" : "bear"} ${index === highlight ? "target" : ""}`}>
            <line x1={x(index)} x2={x(index)} y1={y(high)} y2={y(low)} />
            <rect x={x(index) - candleWidth / 2} y={bodyTop} width={candleWidth} height={bodyHeight} />
            <text className="chart-bar-number" x={x(index)} y={height - 10} textAnchor="middle">{index + 1}</text>
          </g>;
        })}
      </svg>
    </div>
  );
}
